import { Dayjs } from "dayjs";
import { useSettings } from "../SettingsProvider";
import {
  dayjsToStringWithSettings,
  dayjsToStringWithTimeAndSettings,
} from "./index";

/**
 * Hook personnalisé pour formatter les dates selon les préférences utilisateur
 */
export const useDateFormatting = () => {
  const { settings } = useSettings();

  const formatDate = (date: Dayjs | undefined | null): string => {
    return dayjsToStringWithSettings(
      date,
      settings?.timezone || "Africa/Casablanca",
      settings?.dateFormat || "DD/MM/YYYY"
    );
  };

  const formatDateTime = (date: Dayjs | null | undefined): string => {
    return dayjsToStringWithTimeAndSettings(
      date,
      settings?.timezone || "Africa/Casablanca",
      settings?.dateFormat || "DD/MM/YYYY"
    );
  };

  return {
    formatDate,
    formatDateTime,
    timezone: settings?.timezone || "Africa/Casablanca",
    dateFormat: settings?.dateFormat || "DD/MM/YYYY",
  };
};
